export default __webpack_public_path__ + "static/media/logo.0eaa2767.png";